export default function product_quantity_btns() {
  $('.cart-quantity-wrapper .increase-quantity').each(function () {
    $(this).click(function() {
      const parent = $(this).parent();
      $('.quantity input', parent).val(function(i , oldval) {
        if ($('.quantity input', parent).attr('max') == +oldval) {
          return oldval;
        }
        $('.quantity input', parent).trigger('change');
        return ++oldval;
      });
    });
  });
  $('.cart-quantity-wrapper .decrease-quantity').each(function () {
    $(this).click(function() {
      const parent = $(this).parent();
      $('.quantity input', parent).val(function(i , oldval) {
        if (oldval == 1) {
          return oldval;
        }

        $('.quantity input', parent).trigger('change');
        return --oldval;
      });
    });
  });
$('.cart-quantity-wrapper .input-text').each(function () {
  $(this).attr('type', 'text');
});
}
